export enum BulkImportUserToogleActionName {
  EmailNewUsers = 'emailNewUsers',
  UpdateExistingUsers = 'updateExistingUsers',
  DeleteMissingUsers = 'deleteMissingUsers',
}
